import React, { useState } from "react";
import { Section } from "./Section";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    id: "review-sarah",
    name: "Sarah Mitchell",
    company: "TechCorp Global",
    quote:
      "Conquest transformed our infrastructure. Downtime is a thing of the past.",
    avatar:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzkxOTY2NDh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "review-james",
    name: "James Rodriguez",
    company: "FinServe Inc",
    quote:
      "Their 24/7 support and proactive monitoring saved us countless hours.",
    avatar:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzkxOTY2NDh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "review-emily",
    name: "Emily Chen",
    company: "HealthTech Solutions",
    quote:
      "The cloud migration was seamless. We're now more agile and secure than ever.",
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzkxOTY2NDh8MA&ixlib=rb-4.1.0&q=85",
  },
];

const STARS = [
  { id: "star-1" },
  { id: "star-2" },
  { id: "star-3" },
  { id: "star-4" },
  { id: "star-5" },
];

export const Testimonials = () => {
  const [activeDot, setActiveDot] = useState(0);

  return (
    <Section id="reviews" className="bg-zinc-950 py-24 lg:py-32 border-t border-white/5">
      <div className="reveal-up max-w-2xl">
        <div className="text-xs uppercase tracking-[0.22em] text-[#FF4500] font-semibold">
          Testimonials
        </div>
        <h2
          className="mt-4 text-4xl sm:text-5xl font-black tracking-[-0.02em] text-white"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Trusted by Industry Leaders
        </h2>
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6 lg:gap-8 xl:gap-10">
        {TESTIMONIALS.map((t) => (
          <article
            key={t.id}
            data-testid={t.id}
            className="reveal-up bg-white/[0.03] border border-white/10 rounded-2xl p-8 flex flex-col"
          >
            <div className="flex items-center gap-1 mb-5">
              {STARS.map((s) => (
                <Star
                  key={s.id}
                  className="w-4 h-4 fill-[#FF4500] text-[#FF4500]"
                  strokeWidth={0}
                />
              ))}
            </div>
            <p className="text-base text-zinc-200 leading-relaxed flex-1">
              “{t.quote}”
            </p>
            <div className="mt-7 flex items-center gap-3">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-11 h-11 rounded-full object-cover border border-white/15"
              />
              <div>
                <div className="text-sm font-bold text-white">{t.name}</div>
                <div className="text-xs text-zinc-500">{t.company}</div>
              </div>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-10 flex items-center justify-center gap-2.5">
        {[0, 1, 2].map((i) => (
          <button
            key={`dot-${i}`}
            data-testid={`reviews-dot-${i}`}
            type="button"
            aria-label={`Page ${i + 1}`}
            onClick={() => setActiveDot(i)}
            className={`h-2 rounded-full transition-all duration-300 ${
              activeDot === i
                ? "w-8 bg-[#FF4500]"
                : "w-2 bg-white/20 hover:bg-white/40"
            }`}
          />
        ))}
      </div>
    </Section>
  );
};

export default Testimonials;
